import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import UserResource from './UserResource';

export default class UsersResource extends BaseResource {
  constructor() {
    super({ url: '/api/users' });
  }

  list(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  user(id) {
    return new UserResource(`${this.url}/${id}`);
  }
}
